import { Colors, Container, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import {
    INTRO_DESCRIPTION,
    MEETINGS_TITLE,
} from '@/pages/ThematicMeetings/components/meetingStyles';

interface PlanIntroCardProps {
    dataTestId?: string;
}

/**
 * Purely decorative card opening the plan page ("Create a Meeting Plan"). It has no action of its
 * own: the page around it already offers every action (back, edit, calendar).
 */
export const PlanIntroCard = ({
    dataTestId = 'thematic-meeting-plan-intro',
}: PlanIntroCardProps) => {
    const { t } = useAmelioTranslations();

    return (
        <Container
            p={'md'}
            borderRadius={'2xl'}
            border={'white'}
            background={'translucent'}
            glass={'sm'}
            className={'flex max-w-[400px] items-center gap-6'}
            dataTestId={dataTestId}
        >
            <Container
                borderRadius={'full'}
                className={
                    'bg-primary/10 flex h-[60px] w-[60px] shrink-0 items-center justify-center'
                }
            >
                <Icon
                    name={'time-calendar-tick'}
                    size={36}
                    color={Colors.PRIMARY}
                    strokeWidth={1.8}
                    ariaHidden
                />
            </Container>

            <div className={'flex flex-col gap-2'}>
                {/* `Text`, not `Heading`: this card is purely decorative (see the component's own
                    doc above) and sits ahead of the plan's real `h2` title in `MeetingPlanHeader`
                    — a second `h2` here would be a duplicate landmark for no content of its own. */}
                <Text
                    color={Colors.NAVY}
                    className={MEETINGS_TITLE}
                >
                    {t('thematicMeetings.plan.introTitle')}
                </Text>

                <Text className={INTRO_DESCRIPTION}>
                    {t('thematicMeetings.plan.introDescription')}
                </Text>
            </div>
        </Container>
    );
};
